import { ApiError } from "./client";

/**
 * Retry policy for the app's bootstrap queries.
 *
 * 4xx answers are permanent, so retrying only delays the error message.
 * Network failures (0) and timeouts (408) are transient despite being < 500,
 * so they must still retry or a blip strands the query that decides what the
 * app can show.
 */
export const retryUnlessPermanent = (
	failureCount: number,
	error: unknown,
): boolean => {
	const isPermanent =
		error instanceof ApiError &&
		error.statusCode >= 400 &&
		error.statusCode < 500 &&
		error.statusCode !== 408;

	return !isPermanent && failureCount < 2;
};
